import React from 'react';
import { Backdrop, Box, CircularProgress, Stack, Typography } from '@mui/material';
import { CommonOverlayLoaderProps } from '../types/common.types';

const CommonOverlayLoader: React.FC<CommonOverlayLoaderProps> = ({
  open,
  text = 'Assigning...',
  zIndex = 1600,
}) => {
  return (
    <Backdrop
      open={open}
      sx={{
        color: '#2F7E8E',
        zIndex,
        backgroundColor: 'rgba(22, 34, 38, 0.45)',
      }}
    >
      <Stack
        alignItems="center"
        spacing={1.25}
        sx={{
          backgroundColor: '#ffffff',
          border: '1px solid #e2eef1',
          borderRadius: 2,
          px: 3,
          py: 2.25,
          minWidth: 220,
          boxShadow: '0 16px 44px rgba(16, 29, 34, 0.24)',
        }}
      >
        <Box sx={{ position: 'relative', width: 58, height: 58 }}>
          <CircularProgress size={58} thickness={4.8} sx={{ color: '#2F7E8E' }} />
        </Box>
        <Typography fontWeight={700} sx={{ color: '#2F7E8E' }}>
          {text}
        </Typography>
      </Stack>
    </Backdrop>
  );
};

export default CommonOverlayLoader;
